import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-gradient-to-r from-[#F5B731] from-0% via-[#F5B731] via-15% via-[#0D1F40] via-50% to-[#0a1628] backdrop-blur-md shadow-lg' : 'bg-gradient-to-r from-[#F5B731]/40 from-0% via-[#F5B731]/40 via-15% via-[#0D1F40]/30 via-50% to-transparent'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/445rsfvz_Logo%20Horizontal%20TRANSPARENTE.png" 
              alt="CryPT-BR" 
              className="h-[180px] md:h-[198px] w-auto transform hover:scale-105 transition-transform duration-300"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-[#00E5A0] transition-colors duration-200 font-medium"
            >
              {t('nav.aboutUs')}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-[#00E5A0] transition-colors duration-200 font-medium"
            >
              {t('nav.services')}
            </button>
            <button
              onClick={() => scrollToSection('media-partners')}
              className="text-white hover:text-[#00E5A0] transition-colors duration-200 font-medium"
            >
              {t('nav.mediaPartners')}
            </button>
            <LanguageSelector />
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#F5C518] hover:bg-[#00D4FF] text-black font-bold px-6 py-2 rounded-md transition-all duration-200 hover:scale-105 shadow-lg shadow-[#F5C518]/20 hover:shadow-[#00D4FF]/30"
            >
              {t('nav.contact')}
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white hover:text-[#00D4FF] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0a1628]/98 backdrop-blur-md border-t border-gray-700 py-4 space-y-4 animate-in slide-in-from-top">
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#00E5A0] transition-colors"
            >
              {t('nav.aboutUs')}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#00E5A0] transition-colors"
            >
              {t('nav.services')}
            </button>
            <button
              onClick={() => scrollToSection('media-partners')}
              className="block w-full text-left px-4 py-2 text-white hover:text-[#00E5A0] transition-colors"
            >
              {t('nav.mediaPartners')}
            </button>
            <div className="px-4 py-2">
              <LanguageSelector />
            </div>
            <div className="px-4">
              <Button
                onClick={() => scrollToSection('contact')}
                className="w-full bg-[#F5C518] hover:bg-[#00D4FF] text-black font-bold py-3 rounded-md"
              >
                {t('nav.contact')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;